import { render, staticRenderFns } from "./MSODiscountRuleBase.vue?vue&type=template&id=f34f046e&"
import script from "./MSODiscountRuleBase.vue?vue&type=script&lang=js&"
export * from "./MSODiscountRuleBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports